import { Button } from '@mantine/core'

import { useQueryGetUserAddresses } from '@flecto/core/shared'
import { useTranslation } from '@flecto/translations'
import { Result } from '@flecto/ui'
import { Page } from '@flecto/ui/saas'

import { AddressCard } from '../components/AddressCard/AddressCard'
import { useAddressDrawer } from '../hooks/useAddressDrawer'

export function UserAddressesPage() {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_locations' })
  const { openDrawer } = useAddressDrawer()
  const { data, isLoading } = useQueryGetUserAddresses()

  const ActionButton = () => (
    <Button onClick={() => openDrawer()}>{t('actions.new_address')}</Button>
  )

  return (
    <Page withContainer withLoading={isLoading}>
      <Page.Title>{t('title_list')}</Page.Title>
      <Page.Actions>
        <ActionButton />
      </Page.Actions>
      <Page.Content>
        {data?.map((address) => {
          const { id, main, legal } = address
          const isAddressToShow =
            (legal && main) || (!legal && !main) || (!legal && main)

          return (
            isAddressToShow && (
              <AddressCard address={address} mb='md' key={id} />
            )
          )
        })}
        {!data?.length && !isLoading && (
          <Result mt='md'>
            <Result.Icon variant='info' />
            <Result.Title>{t('result_empty_title')}</Result.Title>
            <Result.Description>
              {t('result_empty_description')}
            </Result.Description>
            <Result.Actions>
              <ActionButton />
            </Result.Actions>
          </Result>
        )}
      </Page.Content>
    </Page>
  )
}
